import { render, staticRenderFns } from "./EditComplianceAutoApi.vue?vue&type=template&id=8aae96d4&"
import script from "./EditComplianceAutoApi.vue?vue&type=script&lang=js&"
export * from "./EditComplianceAutoApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports